import requests from "@/common/fetch";
import { Result } from "../common";
import { toCamelCase, toUnderCase } from "@/common/util/transform";
import * as I from "./interface";

/** 查询首页信息 */
export const queryHomeInfo = (): Result<I.QueryHomeInfoResult> => {
  return toCamelCase(requests.post("/mmsapi/brandbank/home/info", {}));
};

/** 更新目标 */
export const updateGoal = (params: I.UpdateGoalParams): Result<boolean> => {
  return toCamelCase(
    requests.post("/mmsapi/brandbank/home/goal/update", toUnderCase(params))
  );
};
